import { AxiosResponse } from 'axios';
import { useQuery } from 'react-query';

import {
  ActiveUsersResponse,
  ActiveUsersTrendResponse,
  AnalyticsRangeParams,
  AnalyticsSeriesResponse,
  AnalyticsVaccinationsParams,
  GeographyResponse,
  LanguagesResponse,
  ProfileFillRateResponse,
  RegistrationFunnelResponse,
  UsersCountSeriesResponse,
  typicodeApi,
} from 'shared/api';

const REGISTRATIONS_KEY = 'analytics/registrations';
const USERS_COUNT_KEY = 'analytics/users-count';
const VACCINATIONS_KEY = 'analytics/vaccinations';

const queryOpts = {
  refetchOnWindowFocus: false,
  keepPreviousData: true,
  staleTime: 60_000,
};

export const useRegistrations = (params: AnalyticsRangeParams) =>
  useQuery<AxiosResponse<AnalyticsSeriesResponse>>(
    [REGISTRATIONS_KEY, params],
    () => typicodeApi.analytics.getRegistrations(params),
    queryOpts,
  );

export const useUsersCount = (params: AnalyticsRangeParams) =>
  useQuery<AxiosResponse<UsersCountSeriesResponse>>(
    [USERS_COUNT_KEY, params],
    () => typicodeApi.analytics.getUsersCount(params),
    queryOpts,
  );

export const useVaccinations = (params: AnalyticsVaccinationsParams) =>
  useQuery<AxiosResponse<AnalyticsSeriesResponse>>(
    [VACCINATIONS_KEY, params],
    () => typicodeApi.analytics.getVaccinations(params),
    queryOpts,
  );

const ACTIVE_USERS_KEY = 'analytics/active-users';
const ACTIVE_USERS_TREND_KEY = 'analytics/active-users-trend';
const GEOGRAPHY_KEY = 'analytics/geography';
const FILL_RATE_KEY = 'analytics/profile-fill-rate';
const LANGUAGES_KEY = 'analytics/languages';
const REGISTRATION_FUNNEL_KEY = 'analytics/registration-funnel';

export const useActiveUsers = () =>
  useQuery<AxiosResponse<ActiveUsersResponse>>(
    [ACTIVE_USERS_KEY],
    () => typicodeApi.analytics.getActiveUsers(),
    queryOpts,
  );

export const useActiveUsersTrend = (params: AnalyticsRangeParams) =>
  useQuery<AxiosResponse<ActiveUsersTrendResponse>>(
    [ACTIVE_USERS_TREND_KEY, params],
    () => typicodeApi.analytics.getActiveUsersTrend(params),
    queryOpts,
  );

export const useGeography = () =>
  useQuery<AxiosResponse<GeographyResponse>>([GEOGRAPHY_KEY], () => typicodeApi.analytics.getGeography(), queryOpts);

export const useProfileFillRate = () =>
  useQuery<AxiosResponse<ProfileFillRateResponse>>(
    [FILL_RATE_KEY],
    () => typicodeApi.analytics.getProfileFillRate(),
    queryOpts,
  );

export const useLanguages = () =>
  useQuery<AxiosResponse<LanguagesResponse>>([LANGUAGES_KEY], () => typicodeApi.analytics.getLanguages(), queryOpts);

export const useRegistrationFunnel = () =>
  useQuery<AxiosResponse<RegistrationFunnelResponse>>(
    [REGISTRATION_FUNNEL_KEY],
    () => typicodeApi.analytics.getRegistrationFunnel(),
    queryOpts,
  );
